import { render, staticRenderFns } from "./CreateExamine.vue?vue&type=template&id=c2f30148&scoped=true"
import script from "./CreateExamine.vue?vue&type=script&lang=js"
export * from "./CreateExamine.vue?vue&type=script&lang=js"
import style0 from "./CreateExamine.vue?vue&type=style&index=0&id=c2f30148&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f30148",
  null
  
)

export default component.exports